import { render, staticRenderFns } from "./ModalBackground.vue?vue&type=template&id=dbf70310&scoped=true&"
import script from "./ModalBackground.vue?vue&type=script&lang=js&"
export * from "./ModalBackground.vue?vue&type=script&lang=js&"
import style0 from "./ModalBackground.vue?vue&type=style&index=0&id=dbf70310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf70310",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/gate/releases/20261022070252/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbf70310')) {
      api.createRecord('dbf70310', component.options)
    } else {
      api.reload('dbf70310', component.options)
    }
    module.hot.accept("./ModalBackground.vue?vue&type=template&id=dbf70310&scoped=true&", function () {
      api.rerender('dbf70310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/ModalBackground.vue"
export default component.exports